export default "__VITE_ASSET__ee0f8bf9__"